import axiosInstance from './axiosInstance';

export const getAssetMetricsCmmsData = async () => {
  const API_URL = process.env.REACT_APP_API_URL;
  try {
    const response = await axiosInstance.get(
      `${API_URL}/asset-metrics-dashboard/cmms-data`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching asset metrics CMMS data:', error);
    throw error;
  }
};

export const getAssetHierarchy = async () => {
  const API_URL = process.env.REACT_APP_API_URL;
  try {
    const response = await axiosInstance.get(
      `${API_URL}/asset-metrics-dashboard/asset-hierarchy`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching asset hierarchy data:', error);
    throw error;
  }
};

export default { getAssetMetricsCmmsData, getAssetHierarchy };
